import { ReactNode } from "react";

import "./style.scss";

const EmptyLeftMenuLayout = ({
    children,
    leftMenu
}: {
    children: ReactNode;
    leftMenu: ReactNode;
}) => {
    return (
        <div className="left-menu-layout">
            <div className="second-left-menu">{leftMenu}</div>
            <div className="children-content">{children}</div>
        </div>
    );
};

export default EmptyLeftMenuLayout;
